export default __webpack_public_path__ + "static/media/pt.39ef1481.svg";